/**
 * @author AshutoshMaurya
 * Upgraded to react:16.8
 */

import { useState, useContext } from 'react';
import {
  Avatar,
  Button,
  Box,
  IconButton,
  Tooltip
} from '@mui/material';

import { Icon } from '@iconify/react';

function UploadPhoto({ setImageSrc, imageSrc, uploadImage, onDeletePhoto }) {

  const handleImageChange = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.onloadend = (readerEvt) => {
      const binaryString = readerEvt.target.result;
      uploadImage(binaryString);
    };
    reader.readAsDataURL(file);
    e.target.value = '';
  };

  return (
    <Box component="div" style={{ textAlign: '-webkit-center' }}>
      <Box sx={{ position: 'relative', display: 'inline-block' }}>
        <label htmlFor="myProfilePhotoUploadBtn">
          <input
            type="file"
            id="myProfilePhotoUploadBtn"
            onChange={handleImageChange}
            style={{ display: 'none' }}
            accept="image/*"
          />
          <Box
            sx={{
              position: 'relative',
              width: 150,
              height: 150,
              cursor: 'pointer',
              '&:hover .hover-overlay': {
                opacity: 1,
              },
            }}
          >
            <Avatar
              src={imageSrc}
              alt="Profile Photo"
              sx={{ 
                height: 150, 
                width: 150,
                border: '4px solid #fff',
                boxShadow: '0 8px 16px 0 rgba(145, 158, 171, 0.24)'
              }}
            />
            <Box
              className="hover-overlay"
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                bgcolor: 'rgba(22, 28, 36, 0.64)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                opacity: 0,
                transition: 'opacity 0.3s ease'
              }}
            >
              <Icon icon="eva:camera-outline" width={32} height={32} />
            </Box>
            <Box
              className="edit-badge"
              sx={{
                position: 'absolute',
                bottom: 8,
                right: 8,
                width: 32,
                height: 32,
                bgcolor: 'primary.main',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.24)',
                opacity: 1,
                transform: 'scale(1)',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
              }}
            >
              <Icon icon="eva:edit-2-fill" width={18} height={18} />
            </Box>
          </Box>
        </label>
        {/* Delete PFP button - shown only when there's an image */}
        {imageSrc && (
          <Tooltip title="Remove photo">
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                onDeletePhoto && onDeletePhoto();
              }}
              sx={{
                position: 'absolute',
                top: -4,
                right: -4,
                width: 28,
                height: 28,
                bgcolor: 'error.main',
                color: '#fff',
                boxShadow: '0 2px 8px 0 rgba(255, 72, 66, 0.4)',
                '&:hover': {
                  bgcolor: 'error.dark',
                },
                zIndex: 2,
              }}
              size="small"
            >
              <Icon icon="eva:close-fill" width={16} height={16} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  );
}

export default UploadPhoto;
